var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_154",
    "data-name": "Groupe 154",
    transform: "translate(-61 -752)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(61 752)",
    fill: "#5d8c82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "checkmark",
    d: "M10.482,19.444,4.5,13.462l.94-.94,5.042,5.041,9.03-9.029.94.94Z",
    transform: "translate(68.648 758.65)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIcon);
export default __webpack_public_path__ + "static/media/OKIcon.e5f82a649b25817c6d6f571d7b29372d.svg";
export { ForwardRef as ReactComponent };